export default "__VITE_ASSET__BxmfSToe__"